import { getLabel } from "../../../../../../../hooks/use-labels";
import { countryOptions } from "../../../../../../../utils/common-utils";

export const addressFormField = (addressDetails) => {
  const {
    address1,
    countryCode,
    stateCode,
    city,
    postalCode,
    digitalCode,
    latitude,
    longitude,
  } = addressDetails;

  return {
    address1: {
      elementConfigs: {
        label: "Street",
        type: "string",
        required: true,
      },
      value: address1 || "",
    },
    countryCode: {
      elementConfigs: {
        label: "Country",
        type: "select",
        required: true,
        options: countryOptions(),
        disabled: true,
      },
      value: countryCode || "",
    },
    stateCode: {
      elementConfigs: {
        label: "State",
        type: "api-select",
        apiURL: `/states/${countryCode}`,
        labelKey: "name",
        metaKey: "name",
        valueKey: "code",
        apiKey: "states",
        valueOnly: true,
        required: true,
        disabled: true,
      },
      value: stateCode || "",
    },
    city: {
      elementConfigs: {
        label: "City",
        type: "api-select",
        apiURL: ``,
        labelKey: "name",
        metaKey: "name",
        valueKey: "code",
        apiKey: "cities",
        valueOnly: true,
        required: true,
        disabled: true,
      },
      value: city || "",
    },
    postalCode: {
      elementConfigs: {
        label: "Zip code (Optional)",
        type: "string",
        required: false,
        maxLength: 12,
        minLength: 5,
      },
      value: postalCode || "",
    },

    digitalCode: {
      elementConfigs: {
        label: "Digital code (Optional)",
        type: "string",
        required: false,
        maxLength: 12,
        minLength: 5,
      },
      value: digitalCode || "",
    },

    location: {
      elementConfigs: {
        label: getLabel("chooseFromMapLabel"),
        type: "location",
        required: true,
        imgSrc: "/assets/icons/pin-location.svg",
        addressText: address1,
      },
      value: { latitude, longitude },
    },
  };
};
